export default "__VITE_ASSET__C7bB0XE$__"